import { render, staticRenderFns } from "./WorkflowTermsPanel.vue?vue&type=template&id=0e0dd690"
import script from "./WorkflowTermsPanel.vue?vue&type=script&lang=js"
export * from "./WorkflowTermsPanel.vue?vue&type=script&lang=js"
import style0 from "./mqSharedStyles.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0dd690')) {
      api.createRecord('0e0dd690', component.options)
    } else {
      api.reload('0e0dd690', component.options)
    }
    module.hot.accept("./WorkflowTermsPanel.vue?vue&type=template&id=0e0dd690", function () {
      api.rerender('0e0dd690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowTermsPanel.vue"
export default component.exports